var p = Object.defineProperty;
var m = (i, e, t) => e in i ? p(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t;
var h = (i, e, t) => m(i, typeof e != "symbol" ? e + "" : e, t);
import { escape as d } from "./utils/escape.js";
import { hasNativeEmojiSupport as f, substituteUnicodeForColonified as b } from "./utils/emoji.js";
import { encodeAttributes as x } from "./utils/attribute-encoding.js";
import { MENTION_CLASS as n } from "./constants.js";
class z {
  constructor(e, t) {
    h(this, "schema");
    h(this, "config");
    h(this, "text");
    h(this, "nodeNameMap", {
      bold: "b",
      italic: "i",
      anchor: "a",
      code: "code",
      span: "span"
    });
    this.schema = e, this.config = t, this.text = "";
  }
  serializeNode(e) {
    let t = [];
    return e.content.forEach((s) => {
      let a = s.marks || [];
      switch (a = this.filterSerializableMarks(a), this.maybeCloseMarks(t, a), s.type) {
        case this.schema.nodes.hardBreak:
          this.text += "<br>";
          break;
        case this.schema.nodes.text:
          this.maybeOpenMarks(t, a), this.serializeText(s);
          break;
        case this.schema.nodes.template:
          this.maybeOpenMarks(t, a), this.serializeTemplate(s);
          break;
        case this.schema.nodes.mention:
          this.serializeMention(s);
          break;
        case this.schema.nodes.aiPromptData:
          this.serializeAiPromptData(s);
          break;
        case this.schema.nodes.marker:
          break;
        case this.schema.nodes.inlineImage:
          this.serializeImage(s);
          break;
        default:
          throw new Error("Invalid node type in text");
      }
    }), this.maybeCloseMarks(t, []), this.text;
  }
  filterSerializableMarks(e) {
    return e.filter((t) => t.type.spec.serializable !== !1);
  }
  maybeCloseMarks(e, t) {
    if (e.filter((r) => !t.includes(r)).length === 0)
      return;
    let a = e.pop();
    if (!a)
      throw new Error("unreachable");
    this.addClosingTag(a.type), this.maybeCloseMarks(e, t);
  }
  maybeOpenMarks(e, t) {
    t.filter((a) => !e.includes(a)).forEach((a) => {
      e.push(a), this.addOpeningTag(a);
    });
  }
  serializeText(e) {
    let t = e.text || "";
    f() || (t = b(t)), this.text += this.escape(t);
  }
  serializeTemplate(e) {
    this.text += `{{${this.escape(e.attrs.attributePath)}`, e.attrs.fallback && (this.text += `|fallback:"${this.escape(e.attrs.fallback)}"`), this.text += "}}";
  }
  serializeMention(e) {
    this.text += `<a class="${n}" href="${this.escape(e.attrs.uri)}">${this.escape(
      e.attrs.name
    )}</a>`;
  }
  serializeAiPromptData(e) {
    let t = "<span data-ai-prompt-data";
    Object.entries(e.attrs).forEach(([s, a]) => {
      if (a) {
        let r = s.replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`);
        t += ` data-prompt-data-${r}="${this.escape(a)}"`;
      }
    }), this.text += `${t}></span>`;
  }
  serializeImage(e) {
    let { displayWidth: t, width: s, src: a, linkUrl: r, text: l, className: o } = e.attrs, c = `<img class="${n} inline-image" src="${this.escape(a)}" width="${t || s}"${l ? ` alt="${this.escape(l)}"` : ""}${o ? ` data-class-name="${this.escape(o)}"` : ""}>`;
    r && (c = `<a href="${this.escape(r)}">${c}</a>`), this.text += c;
  }
  addClosingTag(e) {
    this.text += `</${this.nodeNameMap[e.name]}>`;
  }
  addOpeningTag(e) {
    this.text += `<${this.nodeNameMap[e.type.name]}`, e.attrs && this.addAttrs(e), this.text += ">";
  }
  addAttrs(e) {
    Object.keys(e.attrs).forEach((t) => {
      let s = x(e.attrs[t]), a = this.escape(s);
      a && (this.text += ` ${t}="${a}"`);
    });
  }
  escape(e) {
    return d(e);
  }
}
export {
  z as TextSerializer
};
